<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="800"
        :fullscreen="isMobile" persistent @keydown.esc="chiudi">
        <v-card>
            <v-card-title class="d-flex align-center">
                <v-icon color="primary" class="mr-2">mdi-calendar-plus</v-icon>
                Nuova scadenza mezzo
            </v-card-title>

            <v-card-text>
                <v-stepper v-model="step" flat>
                    <v-stepper-header>
                        <v-stepper-item title="Pianificazione" value="1" />
                        <v-divider />
                        <v-stepper-item title="Conferma" value="2" />
                    </v-stepper-header>

                    <div class="stepper-scroll-area">
                        <v-stepper-window>
                            <!-- Step 1: dati pianificazione -->
                            <v-stepper-window-item value="1">
                                <v-form ref="formRef">
                                    <v-select v-model="form.tipoScadenzaMezzoId" :items="tipiScadenzaMezzo"
                                        item-title="nome" item-value="id" label="Tipo scadenza"
                                        :rules="[v => !!v || 'Obbligatorio']" />
                                    <v-text-field v-model="form.dataPrevista" type="date" label="Data prevista"
                                        :rules="[v => !!v || 'Obbligatorio']" />
                                    <v-textarea v-model="form.descrizione" label="Descrizione" rows="2" />
                                    <v-checkbox v-model="form.ricorrente"
                                        label="Rendi ricorrente (pianifica subito le prossime occorrenze, a data fissa)"
                                        hint="Se non selezionato, alla chiusura verrà comunque generata una sola prossima occorrenza, calcolata dalla data di completamento effettiva."
                                        persistent-hint />
                                </v-form>
                            </v-stepper-window-item>

                            <!-- Step 2: conferma -->
                            <v-stepper-window-item value="2">
                                <v-card variant="outlined" class="rounded-lg pa-3 mb-3">
                                    <div class="text-caption text-medium-emphasis">Mezzo</div>
                                    <div class="font-weight-medium mb-2">{{ mezzoNome }}</div>

                                    <div class="text-caption text-medium-emphasis">Tipo scadenza</div>
                                    <div class="font-weight-medium mb-2">{{ tipoSelezionatoNome }}</div>

                                    <div class="text-caption text-medium-emphasis">Data prevista</div>
                                    <div class="font-weight-medium mb-2">{{ formattaData(form.dataPrevista) }}</div>
                                </v-card>

                                <v-alert v-if="form.ricorrente" type="info" variant="tonal" density="comfortable"
                                    class="rounded-lg">
                                    <div class="font-weight-medium">Pianificazione ricorrente</div>
                                    <div class="text-body-2">
                                        Verranno generate subito le prossime occorrenze a cadenza fissa, fino
                                        all'orizzonte di anni configurato per l'azienda (Mia Azienda).
                                    </div>
                                </v-alert>

                                <v-alert v-else-if="prossimaDataPreview" type="info" variant="tonal"
                                    density="comfortable" class="rounded-lg">
                                    <div class="font-weight-medium">Prossima scadenza pianificata</div>
                                    <div class="text-body-2">
                                        Il tipo "{{ tipoSelezionatoNome }}" ha una frequenza configurata: alla chiusura
                                        verrà generata automaticamente una nuova scadenza, con data calcolata dalla
                                        data di completamento effettiva (in anteprima, se completata oggi:
                                        <strong>{{ formattaData(prossimaDataPreview) }}</strong>).
                                    </div>
                                </v-alert>
                            </v-stepper-window-item>
                        </v-stepper-window>
                    </div>
                </v-stepper>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Annulla</v-btn>
                <v-btn v-if="step === '2'" variant="text" @click="step = '1'">Indietro</v-btn>
                <v-btn v-if="step === '1'" color="primary" @click="vaiAConferma">Avanti</v-btn>
                <v-btn v-else color="primary" :loading="salvataggio" @click="salva">Conferma e pianifica</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DialogNuovaScadenzaMezzo",

    props: {
        modelValue: { type: Boolean, default: false },
        mezzoId: { type: [Number, String], required: true },
    },
    emits: ["update:modelValue", "salvato"],

    data() {
        return {
            step: "1",
            salvataggio: false,
            form: this.formVuoto(),
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
        tipiScadenzaMezzo() {
            return this.$store.getters["tipiScadenzaMezzo/lista"];
        },
        mezzoNome() {
            const m = this.$store.getters["mezzi/corrente"];
            return m && m.id === Number(this.mezzoId) ? m.nome : `Mezzo #${this.mezzoId}`;
        },
        tipoSelezionato() {
            return this.tipiScadenzaMezzo.find(t => t.id === this.form.tipoScadenzaMezzoId) || null;
        },
        tipoSelezionatoNome() {
            return this.tipoSelezionato ? this.tipoSelezionato.nome : "";
        },
        prossimaDataPreview() {
            if (!this.tipoSelezionato || !this.form.dataPrevista) return null;
            return this.calcolaProssimaData(
                this.form.dataPrevista,
                this.tipoSelezionato.frequenzaValore,
                this.tipoSelezionato.frequenzaUnita
            );
        },
    },

    watch: {
        modelValue(val) {
            if (val) {
                this.step = "1";
                this.form = this.formVuoto();
                this.$store.dispatch("tipiScadenzaMezzo/carica");
                this.$store.dispatch("mezzi/caricaDettaglio", this.mezzoId);
            }
        },
    },

    methods: {
        formVuoto() {
            return {
                tipoScadenzaMezzoId: null,
                dataPrevista: new Date().toISOString().substr(0, 10),
                descrizione: "",
                ricorrente: false,
            };
        },

        formattaData(iso) {
            if (!iso) return "";
            return new Date(iso + "T00:00:00").toLocaleDateString("it-IT", {
                day: "numeric", month: "long", year: "numeric",
            });
        },

        // Anteprima client-side della prossima scadenza, stessa logica di
        // DialogNuovaManutenzione (mirror di AutomazioneScadenze.CalcolaProssimaData
        // lato backend, confrontando per nome dell'enum poiché il backend lo
        // serializza come stringa). Solo a scopo informativo.
        calcolaProssimaData(dataIso, frequenzaValore, frequenzaUnita) {
            if (!frequenzaValore || !frequenzaUnita) return null;
            const d = new Date(dataIso + "T00:00:00");
            switch (frequenzaUnita) {
                case "Giorni": d.setDate(d.getDate() + frequenzaValore); break;
                case "Settimane": d.setDate(d.getDate() + frequenzaValore * 7); break;
                case "Mesi": d.setMonth(d.getMonth() + frequenzaValore); break;
                case "Anni": d.setFullYear(d.getFullYear() + frequenzaValore); break;
                default: return null;
            }
            return this.toIsoLocale(d);
        },

        toIsoLocale(d) {
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, "0");
            const g = String(d.getDate()).padStart(2, "0");
            return `${y}-${m}-${g}`;
        },

        vaiAConferma() {
            if (!this.$refs.formRef.validate()) return;
            this.step = "2";
        },

        chiudi() {
            this.$emit("update:modelValue", false);
        },

        async salva() {
            this.salvataggio = true;
            try {
                await this.$store.dispatch("scadenzeMezzo/pianifica", {
                    mezzoId: this.mezzoId,
                    tipoScadenzaMezzoId: this.form.tipoScadenzaMezzoId,
                    dataPrevista: this.form.dataPrevista,
                    descrizione: this.form.descrizione,
                    ricorrente: this.form.ricorrente,
                });
                this.$emit("salvato");
                this.chiudi();
            } catch (error) {
                console.log(error);
            }
            this.salvataggio = false;
        },
    },
};
</script>

<style scoped>
.stepper-scroll-area {
    height: 320px;
    overflow-y: auto;
}
</style>
